function getEnumDescription(value) {
  switch (value){
    case EMAIL: return "Email";
    case CALL: return "Дзвінок";
    case ZOOM: return "Zoom";
    case TEAMS: return "Teams";
    case APPOINTMENT: return "Зустріч";
    default: return "";
  }
}

function getTypes(){
  return [
    { value: EMAIL, icon: "mdi-email" },
    { value: CALL, icon: "mdi-phone-hangup" },
    { value: ZOOM, icon: "mdi-laptop-account" },
    { value: TEAMS, icon: "mdi-microsoft-teams" },
    { value: APPOINTMENT, icon: "mdi-account-switch" },
  ];
}

var EMAIL= 1;
var CALL= 2;
var ZOOM= 3;
var TEAMS= 4;
var APPOINTMENT= 5;

export {
  EMAIL,
  CALL,
  ZOOM,
  TEAMS,
  APPOINTMENT,
  getEnumDescription,
  getTypes,
};